import React, { useState, useEffect } from "react";
import axios from "axios";

import { apiBaseUrl } from '../../../../../../../services/config';
import { useTheme } from "context/ThemeContext";
const API = apiBaseUrl;
const auth = () => ({
  headers: {
    Authorization: `Bearer ${
      sessionStorage.getItem("platform_token") ||
      localStorage.getItem("platform_token") || ""
    }`
  }
});

const dlCSV = async (url, filename) => {
  try {
    const res = await axios.get(url, { ...auth(), responseType: "blob" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([res.data], { type: "text/csv;charset=utf-8;" }));
    a.download = filename;
    document.body.appendChild(a); a.click();
    document.body.removeChild(a); URL.revokeObjectURL(a.href);
  } catch(e) { alert("Download failed: " + (e.response?.data?.detail || e.message)); }
};

const fmt = (n) => n != null
  ? `₹${Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 })}` : "—";

const Btn = ({onClick,disabled,color="cyan",children,style={}}) => {
  const { T } = useTheme();
  return (
    <button onClick={onClick} disabled={disabled} style={{
      padding:"9px 20px", borderRadius:8,
      cursor:disabled?"not-allowed":"pointer",
      background:color==="cyan"
        ? `linear-gradient(135deg,${T.cyan},${T.purple})`
        : `${T[color]||T.green}18`,
      border:color==="cyan"?"none":`1px solid ${T[color]||T.green}35`,
      color:color==="cyan"?"#fff":T[color]||T.green,
      fontFamily:"Outfit,sans-serif",fontSize:13,fontWeight:800,
      opacity:disabled?0.6:1, ...style
    }}>{children}</button>
  );
};

const Tag = ({children,color}) => {
  const { T } = useTheme();
  return (
    <span style={{padding:"2px 10px",borderRadius:100,background:`${T[color]||color}18`,
      border:`1px solid ${T[color]||color}35`,color:T[color]||color,
      fontSize:11,fontWeight:700,whiteSpace:"nowrap"}}>{children}</span>
  );
};

const SumCard = ({label,value,color,sub}) => {
  const { T } = useTheme();
  return (
    <div style={{padding:"14px 18px",background:T.card,border:`1px solid ${T.border}`,
      borderRadius:10,flex:1,minWidth:140}}>
      <div style={{fontSize:10,color:T.muted,fontWeight:700,textTransform:"uppercase",
        letterSpacing:"0.08em",marginBottom:5}}>{label}</div>
      <div style={{fontSize:20,fontWeight:900,color:T[color]||color||T.cyan}}>{value}</div>
      {sub && <div style={{fontSize:10,color:T.dim,marginTop:2}}>{sub}</div>}
    </div>
  );
};

const currentMonth = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`;
};
const currentFY = () => {
  const d = new Date(), y = d.getFullYear();
  return d.getMonth()>=3 ? `${y}-${String(y+1).slice(-2)}` : `${y-1}-${String(y).slice(-2)}`;
};


// ── Period selector shared by TDS and PF ──────────────────────
const PeriodSelector = ({periodType, setPeriodType, periodValue, setPeriodValue, fy, setFy}) => {
  const { T, theme } = useTheme();
  const inp = (x={}) => ({
    padding:"8px 12px", border:`1px solid ${T.border}`, borderRadius:7,
    background:T.inp_bg, color:T.text,
    fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none",
    boxSizing:"border-box", ...x
  });
  const TYPES = [
    {key:"monthly",     label:"Monthly"},
    {key:"quarterly",   label:"Quarterly"},
    {key:"half_yearly", label:"Half-Yearly"},
    {key:"yearly",      label:"Yearly"},
  ];
  return (
    <div style={{display:"flex",gap:10,alignItems:"flex-end",flexWrap:"wrap"}}>
      {/* Period type pills */}
      <div>
        <label style={{fontSize:10,fontWeight:700,color:T.muted,display:"block",marginBottom:5,textTransform:"uppercase",letterSpacing:"0.07em"}}>Period</label>
        <div style={{display:"flex",gap:4}}>
          {TYPES.map(t=>(
            <button key={t.key} onClick={()=>{ setPeriodType(t.key); setPeriodValue(t.key==="monthly"?currentMonth():t.key==="quarterly"?"Q1":t.key==="half_yearly"?"H1":""); }}
              style={{padding:"6px 14px",borderRadius:8,border:"none",cursor:"pointer",
                fontFamily:"Outfit,sans-serif",fontSize:12,fontWeight:700,
                background:periodType===t.key?`linear-gradient(135deg,${T.cyan},${T.purple})`:T.toggle_bg,
                color:periodType===t.key?"#fff":T.muted}}>
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {/* Dynamic value picker */}
      {periodType==="monthly" && (
        <div>
          <label style={{fontSize:10,fontWeight:700,color:T.muted,display:"block",marginBottom:5,textTransform:"uppercase",letterSpacing:"0.07em"}}>Month</label>
          <input type="month" value={periodValue} onChange={e=>setPeriodValue(e.target.value)}
            style={inp({width:155,colorScheme:theme})}/>
        </div>
      )}
      {periodType==="quarterly" && (
        <div>
          <label style={{fontSize:10,fontWeight:700,color:T.muted,display:"block",marginBottom:5,textTransform:"uppercase",letterSpacing:"0.07em"}}>Quarter</label>
          <select value={periodValue} onChange={e=>setPeriodValue(e.target.value)} style={inp({width:100,cursor:"pointer"})}>
            {["Q1","Q2","Q3","Q4"].map(q=>(
              <option key={q} style={{background:T.opt_bg}}>{q}</option>
            ))}
          </select>
        </div>
      )}
      {periodType==="half_yearly" && (
        <div>
          <label style={{fontSize:10,fontWeight:700,color:T.muted,display:"block",marginBottom:5,textTransform:"uppercase",letterSpacing:"0.07em"}}>Half</label>
          <select value={periodValue} onChange={e=>setPeriodValue(e.target.value)} style={inp({width:120,cursor:"pointer"})}>
            <option style={{background:T.opt_bg}}>H1 (Apr–Sep)</option>
            <option style={{background:T.opt_bg}}>H2 (Oct–Mar)</option>
          </select>
        </div>
      )}
      {periodType!=="monthly" && (
        <div>
          <label style={{fontSize:10,fontWeight:700,color:T.muted,display:"block",marginBottom:5,textTransform:"uppercase",letterSpacing:"0.07em"}}>Financial Year</label>
          <input value={fy} onChange={e=>setFy(e.target.value)} style={inp({width:100})} placeholder="2025-26"/>
        </div>
      )}
    </div>
  );
};


// ══════════════════════════════════════════════════════════════
// TDS REPORT TAB
// ══════════════════════════════════════════════════════════════
const TDSTab = () => {
  const { T } = useTheme();
  const [periodType,  setPeriodType]  = useState("monthly");
  const [periodValue, setPeriodValue] = useState(currentMonth());
  const [fy,          setFy]          = useState(currentFY());
  const [data,        setData]        = useState(null);
  const [loading,     setLoading]     = useState(false);
  const [err,         setErr]         = useState("");

  const pv = periodValue.startsWith("H1 ") || periodValue.startsWith("H2 ") ? periodValue.slice(0,2) : periodValue;

  const load = async () => {
    setLoading(true); setErr("");
    try {
      const r = await axios.get(`${API}/reports/tds`, { params:{ period_type:periodType, period_value:pv, fy }, ...auth() });
      setData(r.data);
    } catch(e) { setErr(e.response?.data?.detail || "Failed to load"); }
    finally { setLoading(false); }
  };

  const download = () => dlCSV(
    `${API}/reports/tds/export-csv?period_type=${periodType}&period_value=${encodeURIComponent(pv)}&fy=${fy}`,
    `TDS_Report_${data.period_label.replace(/ /g,"_")}.csv`
  );

  const COLS = [
    {k:"sl",l:"#",w:36},
    {k:"employee_code",l:"Emp Code",w:90},
    {k:"employee_name",l:"Name"},
    {k:"pan",l:"PAN",mono:true,w:110},
    {k:"department",l:"Department"},
    {k:"months_count",l:"Months",center:true,w:60},
    {k:"gross_salary",l:"Gross Salary",fmt:true},
    {k:"basic_salary",l:"Basic",fmt:true},
    {k:"pf_deducted",l:"PF",fmt:true},
    {k:"esi_deducted",l:"ESI",fmt:true},
    {k:"prof_tax",l:"PT",fmt:true},
    {k:"total_deductions",l:"Total Ded.",fmt:true},
    {k:"tds_deducted",l:"TDS Deducted",fmt:true,red:true,bold:true},
    {k:"net_salary",l:"Net Salary",fmt:true},
  ];

  return (
    <div>
      <div style={{display:"flex",gap:10,alignItems:"flex-end",marginBottom:20,flexWrap:"wrap"}}>
        <PeriodSelector {...{periodType,setPeriodType,periodValue,setPeriodValue,fy,setFy}}/>
        <Btn onClick={load} disabled={loading}>{loading?"Loading…":"Generate"}</Btn>
        {data && <Btn color="green" onClick={download}>⬇ Download CSV</Btn>}
      </div>

      {err && <div style={{padding:"10px 14px",borderRadius:9,background:`${T.red}12`,border:`1px solid ${T.red}30`,color:T.red,fontSize:13,fontWeight:600,marginBottom:16}}>⚠️ {err}</div>}

      {data && (
        <>
          {/* Summary */}
          <div style={{display:"flex",gap:10,marginBottom:18,flexWrap:"wrap"}}>
            <SumCard label="Total TDS" value={fmt(data.total_tds)} color="red" sub={data.period_label}/>
            <SumCard label="Total Gross Salary" value={fmt(data.total_gross)} color="cyan"/>
            <SumCard label="Employees" value={data.employee_count} color="purple"/>
            <SumCard label="Period" value={data.period_label} color="amber" sub={`FY ${data.financial_year}`}/>
          </div>

          {/* Table */}
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,overflow:"hidden"}}>
            <div style={{padding:"11px 16px",background:T.card2,borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between"}}>
              <span style={{fontSize:13,fontWeight:700,color:T.text}}>Employee-wise TDS — {data.period_label}</span>
              <Tag color="red">Total TDS: {fmt(data.total_tds)}</Tag>
            </div>
            <div style={{overflowX:"auto"}}>
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <thead><tr style={{background:T.card2}}>
                  {COLS.map(c=><th key={c.k} style={{padding:"9px 12px",textAlign:c.center?"center":"left",fontSize:10,color:T.dim,fontWeight:700,textTransform:"uppercase",borderBottom:`1px solid ${T.border}`,whiteSpace:"nowrap",minWidth:c.w}}>{c.l}</th>)}
                </tr></thead>
                <tbody>
                  {data.rows.map(r=>(
                    <tr key={r.sl} style={{borderBottom:`1px solid ${T.border}`}}
                      onMouseEnter={e=>e.currentTarget.style.background=T.sidebar_hover}
                      onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                      {COLS.map(c=>(
                        <td key={c.k} style={{padding:"9px 12px",fontSize:c.bold?13:12,
                          color:c.red?T.red:c.bold?T.text:T.muted,
                          fontWeight:c.bold?800:400,
                          fontFamily:c.mono?"monospace":"inherit",
                          textAlign:c.center?"center":"left",
                          whiteSpace:"nowrap"}}>
                          {c.fmt ? fmt(r[c.k]) : r[c.k]||"—"}
                        </td>
                      ))}
                    </tr>
                  ))}
                  <tr style={{background:T.card2,borderTop:`2px solid ${T.border}`}}>
                    <td colSpan={12} style={{padding:"11px 12px",fontSize:13,fontWeight:800,color:T.text,textAlign:"right"}}>TOTAL</td>
                    <td style={{padding:"11px 12px",fontSize:14,fontWeight:900,color:T.red}}>{fmt(data.total_tds)}</td>
                    <td style={{padding:"11px 12px",fontSize:12,color:T.muted}}></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
};


// ══════════════════════════════════════════════════════════════
// MONTHLY SALARY TAB (Bank Transfer)
// ══════════════════════════════════════════════════════════════
const SalaryTab = () => {
  const { T, theme } = useTheme();
  const inp = (x={}) => ({
    padding:"8px 12px", border:`1px solid ${T.border}`, borderRadius:7,
    background:T.inp_bg, color:T.text,
    fontFamily:"Outfit,sans-serif", fontSize:13, outline:"none",
    boxSizing:"border-box", ...x
  });
  const [month,   setMonth]   = useState(currentMonth());
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(false);
  const [err,     setErr]     = useState("");

  const load = async () => {
    setLoading(true); setErr("");
    try {
      const r = await axios.get(`${API}/reports/salary`, { params:{ month }, ...auth() });
      setData(r.data);
    } catch(e) { setErr(e.response?.data?.detail || "Failed"); }
    finally { setLoading(false); }
  };

  const download = () => dlCSV(`${API}/reports/salary/export-csv?month=${month}`, `Salary_Bank_Transfer_${month}.csv`);

  const COLS = [
    {k:"sl",l:"#",w:36},{k:"employee_code",l:"Emp Code",w:90},
    {k:"employee_name",l:"Employee Name",bold:true},
    {k:"designation",l:"Designation"},{k:"department",l:"Department"},
    {k:"bank_name",l:"Bank"},{k:"bank_account",l:"Account No",mono:true},
    {k:"bank_ifsc",l:"IFSC",mono:true},
    {k:"bank_branch",l:"Branch"},
    {k:"gross_salary",l:"Gross",fmt:true},
    {k:"pf_deducted",l:"PF",fmt:true},
    {k:"esi_deducted",l:"ESI",fmt:true},
    {k:"prof_tax",l:"PT",fmt:true},
    {k:"tds_deducted",l:"TDS",fmt:true},
    {k:"total_deductions",l:"Total Ded.",fmt:true},
    {k:"net_salary",l:"NET SALARY",fmt:true,green:true,bold:true},
  ];

  return (
    <div>
      <div style={{display:"flex",gap:10,alignItems:"flex-end",marginBottom:20,flexWrap:"wrap"}}>
        <div>
          <label style={{fontSize:10,fontWeight:700,color:T.muted,display:"block",marginBottom:5,textTransform:"uppercase",letterSpacing:"0.07em"}}>Month</label>
          <input type="month" value={month} onChange={e=>setMonth(e.target.value)} style={inp({width:155,colorScheme:theme})}/>
        </div>
        <Btn onClick={load} disabled={loading}>{loading?"Loading…":"Generate"}</Btn>
        {data && <Btn color="green" onClick={download}>⬇ Download CSV (Bank Transfer)</Btn>}
      </div>

      {/* Info banner */}
      <div style={{padding:"12px 16px",background:`${T.amber}08`,border:`1px solid ${T.amber}20`,borderRadius:9,marginBottom:18,fontSize:12.5,color:T.muted,lineHeight:1.7}}>
        <strong style={{color:T.amber}}>🏦 Bank Transfer File</strong> — Upload this CSV to your bank portal (NEFT/RTGS bulk upload) to process salary payments. Verify account numbers and IFSC codes before uploading.
      </div>

      {err && <div style={{padding:"10px 14px",borderRadius:9,background:`${T.red}12`,border:`1px solid ${T.red}30`,color:T.red,fontSize:13,fontWeight:600,marginBottom:16}}>⚠️ {err}</div>}

      {data && (
        <>
          <div style={{display:"flex",gap:10,marginBottom:18,flexWrap:"wrap"}}>
            <SumCard label="Total Net to Transfer" value={fmt(data.total_net)} color="green" sub="Bank disbursement amount"/>
            <SumCard label="Total Gross" value={fmt(data.total_gross)} color="cyan"/>
            <SumCard label="Total Deductions" value={fmt(data.total_deductions)} color="red"/>
            <SumCard label="Employees" value={data.employee_count} color="purple" sub={data.month}/>
          </div>

          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,overflow:"hidden"}}>
            <div style={{padding:"11px 16px",background:T.card2,borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between"}}>
              <span style={{fontSize:13,fontWeight:700,color:T.text}}>Salary Bank Transfer — {data.month}</span>
              <Tag color="green">Net Transfer: {fmt(data.total_net)}</Tag>
            </div>
            <div style={{overflowX:"auto"}}>
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <thead><tr style={{background:T.card2}}>
                  {COLS.map(c=><th key={c.k} style={{padding:"9px 12px",textAlign:"left",fontSize:10,color:T.dim,fontWeight:700,textTransform:"uppercase",borderBottom:`1px solid ${T.border}`,whiteSpace:"nowrap"}}>{c.l}</th>)}
                </tr></thead>
                <tbody>
                  {data.rows.map(r=>(
                    <tr key={r.sl} style={{borderBottom:`1px solid ${T.border}`}}
                      onMouseEnter={e=>e.currentTarget.style.background=T.sidebar_hover}
                      onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                      {COLS.map(c=>(
                        <td key={c.k} style={{padding:"9px 12px",fontSize:c.bold?13:12,
                          color:c.green?T.green:c.bold?T.text:T.muted,
                          fontWeight:c.bold?800:400,fontFamily:c.mono?"monospace":"inherit",
                          whiteSpace:"nowrap"}}>
                          {c.fmt ? fmt(r[c.k]) : r[c.k]||"—"}
                        </td>
                      ))}
                    </tr>
                  ))}
                  <tr style={{background:T.card2,borderTop:`2px solid ${T.border}`}}>
                    <td colSpan={8} style={{padding:"11px 12px",fontSize:13,fontWeight:800,color:T.text,textAlign:"right"}}>TOTAL</td>
                    <td style={{padding:"11px 12px",fontSize:12,color:T.cyan,fontWeight:700}}>{fmt(data.total_gross)}</td>
                    <td colSpan={4}></td>
                    <td style={{padding:"11px 12px",fontSize:12,color:T.red,fontWeight:700}}>{fmt(data.total_deductions)}</td>
                    <td style={{padding:"11px 12px",fontSize:14,fontWeight:900,color:T.green}}>{fmt(data.total_net)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
};


// ══════════════════════════════════════════════════════════════
// PF REPORT TAB
// ══════════════════════════════════════════════════════════════
const PFTab = () => {
  const { T } = useTheme();
  const [periodType,  setPeriodType]  = useState("monthly");
  const [periodValue, setPeriodValue] = useState(currentMonth());
  const [fy,          setFy]          = useState(currentFY());
  const [data,        setData]        = useState(null);
  const [loading,     setLoading]     = useState(false);
  const [err,         setErr]         = useState("");

  const pv = periodValue.startsWith("H1 ") || periodValue.startsWith("H2 ") ? periodValue.slice(0,2) : periodValue;

  const load = async () => {
    setLoading(true); setErr("");
    try {
      const r = await axios.get(`${API}/reports/pf`, { params:{ period_type:periodType, period_value:pv, fy }, ...auth() });
      setData(r.data);
    } catch(e) { setErr(e.response?.data?.detail || "Failed"); }
    finally { setLoading(false); }
  };

  const download = () => dlCSV(
    `${API}/reports/pf/export-csv?period_type=${periodType}&period_value=${encodeURIComponent(pv)}&fy=${fy}`,
    `PF_Report_${data.period_label.replace(/ /g,"_")}.csv`
  );

  const COLS = [
    {k:"sl",l:"#",w:36},{k:"employee_code",l:"Emp Code",w:90},
    {k:"employee_name",l:"Name",bold:true},
    {k:"uan",l:"UAN",mono:true,w:115},
    {k:"pf_number",l:"PF Member ID",mono:true,w:115},
    {k:"department",l:"Dept"},
    {k:"months_count",l:"Months",center:true,w:55},
    {k:"basic_salary",l:"Basic Salary",fmt:true},
    {k:"pf_wages",l:"PF Wages",fmt:true},
    {k:"employee_pf_12",l:"Emp PF 12%",fmt:true,cyan:true,bold:true},
    {k:"employer_epf_367",l:"Empyr EPF 3.67%",fmt:true},
    {k:"employer_eps_833",l:"Empyr EPS 8.33%",fmt:true},
    {k:"employer_total",l:"Empyr Total",fmt:true},
    {k:"admin_charges",l:"Admin 0.5%",fmt:true},
    {k:"edli_charges",l:"EDLI 0.5%",fmt:true},
    {k:"total_remittance",l:"Total to EPFO",fmt:true,amber:true,bold:true},
  ];

  return (
    <div>
      <div style={{display:"flex",gap:10,alignItems:"flex-end",marginBottom:20,flexWrap:"wrap"}}>
        <PeriodSelector {...{periodType,setPeriodType,periodValue,setPeriodValue,fy,setFy}}/>
        <Btn onClick={load} disabled={loading}>{loading?"Loading…":"Generate"}</Btn>
        {data && <Btn color="green" onClick={download}>⬇ Download CSV (ECR Format)</Btn>}
      </div>

      <div style={{padding:"12px 16px",background:`${T.cyan}06`,border:`1px solid ${T.border}`,borderRadius:9,marginBottom:18,fontSize:12.5,color:T.muted,lineHeight:1.7}}>
        <strong style={{color:T.cyan}}>🏛️ EPFO Submission</strong> — Remit combined PF amount to EPFO by <strong style={{color:T.amber}}>15th of every month</strong>.
        Upload ECR (Electronic Challan cum Return) via <strong style={{color:T.text}}>unifiedportal-emp.epfindia.gov.in</strong>.
        <span style={{display:"block",marginTop:4,fontSize:11.5}}>
          Breakdown: Employee 12% + Employer EPF 3.67% + Employer EPS 8.33% + Admin 0.5% + EDLI 0.5%
        </span>
      </div>

      {err && <div style={{padding:"10px 14px",borderRadius:9,background:`${T.red}12`,border:`1px solid ${T.red}30`,color:T.red,fontSize:13,fontWeight:600,marginBottom:16}}>⚠️ {err}</div>}

      {data && (
        <>
          <div style={{display:"flex",gap:10,marginBottom:18,flexWrap:"wrap"}}>
            <SumCard label="Grand Total to EPFO" value={fmt(data.grand_total_remit)} color="amber" sub={data.period_label}/>
            <SumCard label="Employee PF (12%)" value={fmt(data.total_employee_pf)} color="cyan"/>
            <SumCard label="Employer EPF (3.67%)" value={fmt(data.total_employer_epf)} color="purple"/>
            <SumCard label="Employer EPS (8.33%)" value={fmt(data.total_employer_eps)} color="green"/>
          </div>

          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,overflow:"hidden"}}>
            <div style={{padding:"11px 16px",background:T.card2,borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between"}}>
              <span style={{fontSize:13,fontWeight:700,color:T.text}}>PF Report — {data.period_label}</span>
              <Tag color="amber">Total to EPFO: {fmt(data.grand_total_remit)}</Tag>
            </div>
            <div style={{overflowX:"auto"}}>
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <thead><tr style={{background:T.card2}}>
                  {COLS.map(c=><th key={c.k} style={{padding:"9px 10px",textAlign:c.center?"center":"left",fontSize:10,color:T.dim,fontWeight:700,textTransform:"uppercase",borderBottom:`1px solid ${T.border}`,whiteSpace:"nowrap"}}>{c.l}</th>)}
                </tr></thead>
                <tbody>
                  {data.rows.map(r=>(
                    <tr key={r.sl} style={{borderBottom:`1px solid ${T.border}`}}
                      onMouseEnter={e=>e.currentTarget.style.background=T.sidebar_hover}
                      onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                      {COLS.map(c=>(
                        <td key={c.k} style={{padding:"9px 10px",fontSize:c.bold?13:12,
                          color:c.amber?T.amber:c.cyan?T.cyan:c.bold?T.text:T.muted,
                          fontWeight:c.bold?800:400,fontFamily:c.mono?"monospace":"inherit",
                          textAlign:c.center?"center":"left",whiteSpace:"nowrap"}}>
                          {c.fmt ? fmt(r[c.k]) : r[c.k]||"—"}
                        </td>
                      ))}
                    </tr>
                  ))}
                  <tr style={{background:T.card2,borderTop:`2px solid ${T.border}`}}>
                    <td colSpan={8} style={{padding:"11px 10px",fontSize:13,fontWeight:800,color:T.text,textAlign:"right"}}>TOTALS</td>
                    <td style={{padding:"11px 10px",fontSize:13,fontWeight:700,color:T.cyan}}>{fmt(data.total_employee_pf)}</td>
                    <td style={{padding:"11px 10px",fontSize:12,fontWeight:700,color:T.muted}}>{fmt(data.total_employer_epf)}</td>
                    <td style={{padding:"11px 10px",fontSize:12,fontWeight:700,color:T.muted}}>{fmt(data.total_employer_eps)}</td>
                    <td style={{padding:"11px 10px",fontSize:12,color:T.muted}}>{fmt(data.total_employer_epf+data.total_employer_eps)}</td>
                    <td style={{padding:"11px 10px",fontSize:12,color:T.muted}}>{fmt(data.total_admin)}</td>
                    <td style={{padding:"11px 10px",fontSize:12,color:T.muted}}>{fmt(data.total_edli)}</td>
                    <td style={{padding:"11px 10px",fontSize:14,fontWeight:900,color:T.amber}}>{fmt(data.grand_total_remit)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
};


// ══════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ══════════════════════════════════════════════════════════════
export default function Reports() {
  const { T } = useTheme();
  const [tab, setTab] = useState("tds");

  const TABS = [
    { key:"tds",    icon:"🧾", label:"TDS Report",       sub:"Monthly / Quarterly / Half-Yearly / Yearly" },
    { key:"salary", icon:"🏦", label:"Monthly Salary",   sub:"Bank Transfer File"                         },
    { key:"pf",     icon:"🏛️", label:"PF Report",        sub:"EPFO Remittance / ECR Format"               },
  ];

  return (
    <div style={{fontFamily:"Outfit,sans-serif",color:T.text}}>
      {/* Page header */}
      <div style={{marginBottom:22}}>
        <div style={{fontSize:11,color:T.cyan,fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:4}}>PAYROLL</div>
        <h2 style={{fontSize:22,fontWeight:800,margin:"0 0 4px",color:T.text}}>Reports</h2>
        <p style={{fontSize:13.5,color:T.muted,margin:0}}>Generate TDS, Salary Bank Transfer and PF reports for any period</p>
      </div>

      {/* Tabs */}
      <div style={{display:"flex",gap:6,borderBottom:`1px solid ${T.border}`,marginBottom:22}}>
        {TABS.map(t=>(
          <button key={t.key} onClick={()=>setTab(t.key)}
            style={{padding:"11px 20px",borderRadius:"8px 8px 0 0",
              border:`1px solid ${tab===t.key?T.border:"transparent"}`,
              borderBottom:"none",
              background:tab===t.key?T.card:T.card2,
              color:tab===t.key?T.cyan:T.muted,
              cursor:"pointer",fontFamily:"Outfit,sans-serif",
              fontSize:13,fontWeight:700,
              marginBottom:tab===t.key?-1:0,textAlign:"left",minWidth:160}}>
            {t.icon} {t.label}
            <div style={{fontSize:10,color:tab===t.key?T.muted:T.dim,fontWeight:400,marginTop:2}}>{t.sub}</div>
          </button>
        ))}
      </div>

      {/* Content */}
      <div style={{background:T.card,border:`1px solid ${T.border}`,
        borderRadius:"0 12px 12px 12px",padding:"22px 24px"}}>
        {tab==="tds"    && <TDSTab/>}
        {tab==="salary" && <SalaryTab/>}
        {tab==="pf"     && <PFTab/>}
      </div>
    </div>
  );
}
